export default {"src":"/_next/static/media/icon_google.bc53895c.svg","height":24,"width":24};